import { OpportunityType, type UpdateOpportunityInput } from "@/graphql"
import type { Opportunity } from "@/model/DataModel"

export function isValidPrice(value: unknown): boolean {
	const numberValue = Number(value)

	return Number.isFinite(numberValue) && numberValue > 1
}

function calculateUnitPrice(price: number | null | undefined, quantity: number | null | undefined): number | null {
	if (price == null || !Number.isFinite(price) || quantity == null || !Number.isFinite(quantity) || quantity <= 0) {
		return null
	}

	const unitPrice = price / quantity

	return Number.isFinite(unitPrice) ? unitPrice : null
}

export function getOpportunityPricingUpdate(
	opportunity: Opportunity,
	input: Pick<UpdateOpportunityInput, "buildableArea" | "residentialUnits">
): Partial<Opportunity> {
	const price =
		opportunity.type === OpportunityType.ListingLanderz
			? opportunity.call_for_bids
				? null
				: opportunity.price
			: opportunity.priceExpectation
	const update: Partial<Opportunity> = {}

	if (input.buildableArea !== undefined) {
		update.constructible = input.buildableArea
		const unitPrice = calculateUnitPrice(price, input.buildableArea)
		update.pricePerConstructibleSqft =
			unitPrice == null || unitPrice === 0
				? null
				: unitPrice < 15
					? Number(unitPrice.toFixed(2))
					: Math.round(unitPrice)
	}

	if (input.residentialUnits !== undefined) {
		update.residentialUnits = input.residentialUnits
		const unitPrice = calculateUnitPrice(price, input.residentialUnits)
		update.pricePerUnit = unitPrice == null ? null : Math.round((unitPrice + Number.EPSILON) * 100) / 100
	}

	return update
}
